export const ContactBackdrops = () => (
  <>
    <div
      aria-hidden
      className="pointer-events-none absolute -top-40 -right-32 -z-10 h-[640px] w-[640px] rounded-full opacity-60 blur-3xl"
      style={{
        background:
          'radial-gradient(closest-side, rgba(152,193,255,0.55), rgba(255,209,149,0.18) 55%, transparent 75%)',
      }}
    />
    <div
      aria-hidden
      className="pointer-events-none absolute bottom-32 -left-32 -z-10 h-[520px] w-[520px] rounded-full opacity-50 blur-3xl"
      style={{
        background: 'radial-gradient(closest-side, rgba(214,207,255,0.55), transparent 75%)',
      }}
    />
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 -z-10 opacity-[0.06]"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Cpath d='M0 .5H79.5V80' fill='none' stroke='%23142546' stroke-opacity='.45'/%3E%3C/svg%3E\")",
        backgroundSize: '80px 80px',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, black 55%, transparent 95%)',
        maskImage: 'linear-gradient(to bottom, black 0%, black 55%, transparent 95%)',
      }}
    />
  </>
)
